/* "You may also like" rail on the PDP.
 *
 * Data comes from raftor_webhq.catalog.recommendations.get_recommended_items_for
 * (curated Recommended Items rows first, rule-based item-group/price-band/tag
 * fill after) via the shared RecommendationSource (mode: 'for_item').
 *
 * Mounted through window.rfhqProductCard.mountCarousel - the exact same
 * function every Item Carousel Web Page Block (including home's own
 * "Recommended for you" rail) runs through - so this file's only job is
 * building the right element and putting it in the right place; see
 * build_item_carousel.js for why PDP needs a JS-built element instead of a
 * real block, and for the visual config this mirrors from home's block.
 *
 * Whether this rail is actually enabled (Raftor Storefront Feature Settings >
 * Show on Product Page) is enforced entirely inside RecommendationSource -
 * nothing here needs to know about that setting.
 */

import { isPdp, getPdpItemCode, getPdpMainBlock } from '../pdp_widgets/pdp_context.js';
import { buildRecommendationCarouselEl } from './build_item_carousel.js';

frappe.ready(function () {
	if (!window.rfhqProductCard) return;
	if (!isPdp()) return;

	var itemCode = getPdpItemCode();
	if (!itemCode) return;

	var anchor = getPdpMainBlock();
	if (!anchor) return;

	var el = buildRecommendationCarouselEl({
		title: __('You may also like'),
		mode: 'for_item',
		itemCode: itemCode,
		extraClass: 'rfhq-item-carousel--pdp mt-4',
	});

	var flexBlock = anchor.nextElementSibling;
	var insertAfterEl = (flexBlock && flexBlock.classList.contains('d-flex')) ? flexBlock : anchor;
	insertAfterEl.insertAdjacentElement('afterend', el);

	window.rfhqProductCard.mountCarousel(el);
});
